/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { PLANOGRAM_FRAGMENT } from '../fragments'

export const SET_PLANOGRAM = gql`
  mutation SetPlanogram($data: PlanogramInput!) {
    createPlanogram(data: $data) {
      ...Planogram
    }
  }
  ${PLANOGRAM_FRAGMENT}
`
